import axios from "axios";
import { domain } from "../Links/Links";

export async function profileRequest(username, setProfileData, setLoading) {
    setLoading(true)
    const response = await axios.get(domain + '/profile/?username=' + username , {withCredentials: true});

    if (response.data) {
        setProfileData(response.data);
        setTimeout(() => {
            setLoading(false)
        }, 0);
        
    }

    
}